import { SET_USER_DATA } from "./userTypes";

// Action Creators
export const setUserData = (data) => ({
  type: SET_USER_DATA,
  payload: data,
});
